import styled from "styled-components";
import { BbotAlert } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 15px;
`;

export const ReadOnlyBanner = styled(BbotAlert)`
  margin-bottom: 20px;
`;

export const CardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Mirrors the legacy table's ng-class="{'c-red': configType === 'notConfigured', 'c-gray': !is_editable}".
export const HostnameCell = styled.span<{ $notConfigured?: boolean; $nonEditable?: boolean }>`
  color: ${({ $notConfigured, $nonEditable }) =>
    $notConfigured ? "var(--color-error__regular)" : $nonEditable ? "var(--color-neutral__label)" : "inherit"};
`;

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  h2 {
    margin: 0;
  }
`;

export const SaveRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 12px;
`;

// Mirrors edit-hostname-configs.html's <h2 style="color: darkred;">Advanced Options</h2>.
export const AdvancedOptionsHeading = styled.h2`
  color: darkred;
  font-size: 1.3rem;
  margin: 0;
`;

export const LocationAssignmentControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

// Mirrors the display/edit checklists' overflow-y: scroll; height: 150px.
export const ChecklistScroll = styled.div`
  overflow-y: auto;
  margin-bottom: 16px;
`;

export const LocationCustomerGroup = styled.div`
  margin-bottom: 12px;

  h4 {
    margin-bottom: 8px;
  }
`;

// Mirrors the legacy checklists' class="col-xs-4" (3-per-row grid), via wrapping flex
// items instead of a fixed column width so short codes don't waste space.
export const LocationCheckboxGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 24px;
`;

export const LocationCheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  label {
    margin: 0;
  }
`;

export const LocationWarningText = styled.p`
  color: var(--color-error__regular);
  font-style: italic;
  margin-bottom: 4px;
`;
